export const PLAYBOOK_GROUP_LABELS: Record<string, string> = {
  A_quente: 'Quente',
  B_gerou_e_parou: 'Gerou e parou',
  C_travou: 'Travou antes do documento',
  D_nunca_comecou: 'Nunca começou',
  E_fora_do_alvo: 'Fora do alvo',
};

export const PERSONA_LABELS: Record<string, string> = {
  fundador_nao_tecnico: 'Fundador sem time técnico',
  empresa: 'Empresa',
  dev: 'Desenvolvedor',
  curioso: 'Curioso',
  fora_do_alvo: 'Fora do alvo',
};

export const THEME_LABELS: Record<string, string> = {
  app_pequeno_negocio: 'App para pequeno negócio',
  portal_interno: 'Portal interno',
  integracao: 'Integração',
  ecommerce: 'E-commerce',
  saas: 'SaaS',
  jogo_entretenimento: 'Jogo ou entretenimento',
  nao_software: 'Não é software',
};

export function labelOf(map: Record<string, string>, value: string | null | undefined): string {
  if (!value) {
    return '-';
  }
  return map[value] ?? value;
}
